import { Grid, Drawer, Typography, IconButton } from '@mui/material';
import { IServiceData } from './ServiceDataList';
import { ServiceCard } from './ServiceCard';
import { IComponentCss } from '@tap/mui-ui';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useSession } from '../auth';

/*
*   Боковое меню 'Все сервисы'
*/

type IServicesMenuDrawer = {
    baseUrl?: string,
    openServicesMenu: boolean,
    openMenuWidth: number,
    handleServicesMenuClose: () => void,
    serviceList: IServiceData[],
}


const css: IComponentCss = {
    drawer: {
        width: '100%',
        zIndex: 1999,
    },
    icon: {
        width: '38px',
        height: '38px',
    },
    titleWrap: {
        height: '64px',
        pl: 3,
        pr: 1,
        mb: 2,
    },
    cardWrap: {
        pl: 3,
        pr: 3,
        pb: 3,
        overflow: 'auto',
    },
};


const trimPath = (path: string) => path?.replace(/^\/+|\/+$/g, '');


export function ServicesMenuDrawer({
    baseUrl = '',
    openServicesMenu,
    openMenuWidth,
    handleServicesMenuClose,
    serviceList,
}: IServicesMenuDrawer) {

    const { user, systemSettings } = useSession();

    const availableServiceItems = serviceList.filter(item => {
        const service = item.link.split('/')?.[1];
        if (!systemSettings?.apps.find(appCode => service.includes(appCode)))
            return false;

        if (trimPath(window.location.pathname).indexOf(trimPath(item.link)) === 0) {
            return false;
        }

        if (!item.roles || !item.roles.length)
            return true;

        return user && item.roles.filter(role => user.roles.includes(role)).length > 0;
    });

    return (
        <Drawer
            anchor={'left'}
            open={openServicesMenu}
            onClose={handleServicesMenuClose}
            sx={{
                maxWidth: '100%',
                ...css.drawer,
            }}
        >
            <Grid
                sx={{
                    maxWidth: openMenuWidth,
                    width: '100%',
                }}
            >

                <Grid
                    sx={css.titleWrap}
                    container
                    justifyContent='space-between'
                    alignItems='center'
                >
                    <Typography
                        component='h2'
                        variant='h5'
                    >
                        Все сервисы
                    </Typography>

                    <IconButton
                        onClick={handleServicesMenuClose}
                        sx={css.icon}
                    >
                        <ChevronLeftIcon />
                    </IconButton>
                </Grid>

                <Grid
                    container
                    sx={css.cardWrap}
                    spacing={2}
                >
                    {availableServiceItems?.length > 0 && availableServiceItems.map((card: IServiceData) =>
                        <ServiceCard
                            key={card.title}
                            title={card.title}
                            description={card.description}
                            img={card.img}
                            link={`${baseUrl}${card.link}`}
                        />,
                    )}

                    {availableServiceItems?.length === 0 &&
                        <Typography
                            variant={'body1'}
                            mt={3}
                            ml={2}
                        >
                            Нет прав для доступа к другим сервисам системы
                        </Typography>
                    }
                </Grid>

            </Grid>
        </Drawer>
    );
}